<template>
  <b-container>
    <b-row style="margin-top: 25px">
      <b-col cols="12">
        <div style="text-align: center; background-color: #ffc729; border-radius: 25px;">
          <h3>Email & Text</h3>
        </div>
        <email-text
            :profile="profile"
            :session="session"
            :notification-json="notificationsJSON"
        />
      </b-col>
      <b-col v-if="false" vcols="1">
        <h3>Social</h3>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import EmailText from "./emailText";
import notificationsJSON from "../assets/notifications.json"
export default {
  name: "Sessions_Sidebar_Session_Notifications",
  components: {
    EmailText
  },
  props: {
    session: {
      type: Object,
      default: () => {
        return {}
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  mounted() {},
  computed: {
    ...mapGetters({})
  },
  methods: {
  },
  data() {
    return {
      notificationsJSON,
      sessionTitle: this.session && this.session.session &&
      this.session.session.title ? this.session.session .title : 'Title Error',
      sessionTopic: this.session && this.session.session  &&
      this.session.session.topic ? this.session.session.topic : '',
      mainPropsLogo: { blank: false, blankColor: '#777', class: 'm1' }
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
